/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserReportAPI {

  /**
   * Method that returns user's custom reports
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiUserReportList(): CancelablePromise<Array<{
    id: number;
    name: string;
    description: string;
    createdAt: string;
    updatedAt: string;
    filters: {
      orderIds?: Array<number>;
      campaignIds?: Array<number>;
      sspIds?: Array<number>;
      publisherIds?: Array<string>;
      screenIds?: Array<string>;
      countryIds?: Array<string>;
      stateIds?: Array<string>;
      cityIds?: Array<string>;
      postalCodes?: Array<string>;
      venueTypeIds?: Array<number>;
      mediaIds?: Array<number>;
      mediaDimensions?: Array<string>;
      mediaIsPortrait?: boolean;
      mediaIsVideo?: boolean;
      weatherIds?: Array<number>;
      startDate?: string;
      endDate?: string;
    };
    groupBys: Array<'month' | 'day' | 'week' | 'hour' | 'campaign_id' | 'ssp_id' | 'publisher_id' | 'campaign_coordinate_id' | 'screen_id' | 'venue_type_id' | 'media_id' | 'weather_id' | 'order_id' | 'country' | 'state' | 'city' | 'postal_code' | 'media_dimension' | 'media_is_portrait' | 'media_is_video'>;
    sortBys?: Array<'month' | 'day' | 'week' | 'hour' | 'campaign_id' | 'ssp_id' | 'publisher_id' | 'campaign_coordinate_id' | 'screen_id' | 'venue_type_id' | 'media_id' | 'weather_id' | 'order_id' | 'country' | 'state' | 'city' | 'postal_code' | 'media_dimension' | 'media_is_portrait' | 'media_is_video'>;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/user-report/list',
    });
  }

  /**
   * Method that update a given user custom report
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static putApiUserReport(
    requestBody: {
      id: number;
      name: string;
      description: string;
      createdAt: string;
      updatedAt: string;
      filters: {
        orderIds?: Array<number>;
        campaignIds?: Array<number>;
        sspIds?: Array<number>;
        publisherIds?: Array<string>;
        screenIds?: Array<string>;
        countryIds?: Array<string>;
        stateIds?: Array<string>;
        cityIds?: Array<string>;
        postalCodes?: Array<string>;
        venueTypeIds?: Array<number>;
        mediaIds?: Array<number>;
        mediaDimensions?: Array<string>;
        mediaIsPortrait?: boolean;
        mediaIsVideo?: boolean;
        weatherIds?: Array<number>;
        startDate?: string;
        endDate?: string;
      };
      groupBys: Array<'month' | 'day' | 'week' | 'hour' | 'campaign_id' | 'ssp_id' | 'publisher_id' | 'campaign_coordinate_id' | 'screen_id' | 'venue_type_id' | 'media_id' | 'weather_id' | 'order_id' | 'country' | 'state' | 'city' | 'postal_code' | 'media_dimension' | 'media_is_portrait' | 'media_is_video'>;
      sortBys?: Array<'month' | 'day' | 'week' | 'hour' | 'campaign_id' | 'ssp_id' | 'publisher_id' | 'campaign_coordinate_id' | 'screen_id' | 'venue_type_id' | 'media_id' | 'weather_id' | 'order_id' | 'country' | 'state' | 'city' | 'postal_code' | 'media_dimension' | 'media_is_portrait' | 'media_is_video'>;
    },
  ): CancelablePromise<{
    id: number;
    name: string;
    description: string;
    createdAt: string;
    updatedAt: string;
    filters: {
      orderIds?: Array<number>;
      campaignIds?: Array<number>;
      sspIds?: Array<number>;
      publisherIds?: Array<string>;
      screenIds?: Array<string>;
      countryIds?: Array<string>;
      stateIds?: Array<string>;
      cityIds?: Array<string>;
      postalCodes?: Array<string>;
      venueTypeIds?: Array<number>;
      mediaIds?: Array<number>;
      mediaDimensions?: Array<string>;
      mediaIsPortrait?: boolean;
      mediaIsVideo?: boolean;
      weatherIds?: Array<number>;
      startDate?: string;
      endDate?: string;
    };
    groupBys: Array<'month' | 'day' | 'week' | 'hour' | 'campaign_id' | 'ssp_id' | 'publisher_id' | 'campaign_coordinate_id' | 'screen_id' | 'venue_type_id' | 'media_id' | 'weather_id' | 'order_id' | 'country' | 'state' | 'city' | 'postal_code' | 'media_dimension' | 'media_is_portrait' | 'media_is_video'>;
    sortBys?: Array<'month' | 'day' | 'week' | 'hour' | 'campaign_id' | 'ssp_id' | 'publisher_id' | 'campaign_coordinate_id' | 'screen_id' | 'venue_type_id' | 'media_id' | 'weather_id' | 'order_id' | 'country' | 'state' | 'city' | 'postal_code' | 'media_dimension' | 'media_is_portrait' | 'media_is_video'>;
  }> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/user-report',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that create a new user custom report
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiUserReport(
    requestBody: {
      id?: number;
      name: string;
      description: string;
      createdAt?: string;
      updatedAt?: string;
      filters?: {
        orderIds?: Array<number>;
        campaignIds?: Array<number>;
        sspIds?: Array<number>;
        publisherIds?: Array<string>;
        screenIds?: Array<string>;
        countryIds?: Array<string>;
        stateIds?: Array<string>;
        cityIds?: Array<string>;
        postalCodes?: Array<string>;
        venueTypeIds?: Array<number>;
        mediaIds?: Array<number>;
        mediaDimensions?: Array<string>;
        mediaIsPortrait?: boolean;
        mediaIsVideo?: boolean;
        weatherIds?: Array<number>;
        startDate?: string;
        endDate?: string;
      };
      groupBys: Array<'month' | 'day' | 'week' | 'hour' | 'campaign_id' | 'ssp_id' | 'publisher_id' | 'campaign_coordinate_id' | 'screen_id' | 'venue_type_id' | 'media_id' | 'weather_id' | 'order_id' | 'country' | 'state' | 'city' | 'postal_code' | 'media_dimension' | 'media_is_portrait' | 'media_is_video'>;
      sortBys?: Array<'month' | 'day' | 'week' | 'hour' | 'campaign_id' | 'ssp_id' | 'publisher_id' | 'campaign_coordinate_id' | 'screen_id' | 'venue_type_id' | 'media_id' | 'weather_id' | 'order_id' | 'country' | 'state' | 'city' | 'postal_code' | 'media_dimension' | 'media_is_portrait' | 'media_is_video'>;
    },
  ): CancelablePromise<{
    id: number;
    name: string;
    description: string;
    createdAt: string;
    updatedAt: string;
    filters: {
      orderIds?: Array<number>;
      campaignIds?: Array<number>;
      sspIds?: Array<number>;
      publisherIds?: Array<string>;
      screenIds?: Array<string>;
      countryIds?: Array<string>;
      stateIds?: Array<string>;
      cityIds?: Array<string>;
      postalCodes?: Array<string>;
      venueTypeIds?: Array<number>;
      mediaIds?: Array<number>;
      mediaDimensions?: Array<string>;
      mediaIsPortrait?: boolean;
      mediaIsVideo?: boolean;
      weatherIds?: Array<number>;
      startDate?: string;
      endDate?: string;
    };
    groupBys: Array<'month' | 'day' | 'week' | 'hour' | 'campaign_id' | 'ssp_id' | 'publisher_id' | 'campaign_coordinate_id' | 'screen_id' | 'venue_type_id' | 'media_id' | 'weather_id' | 'order_id' | 'country' | 'state' | 'city' | 'postal_code' | 'media_dimension' | 'media_is_portrait' | 'media_is_video'>;
    sortBys?: Array<'month' | 'day' | 'week' | 'hour' | 'campaign_id' | 'ssp_id' | 'publisher_id' | 'campaign_coordinate_id' | 'screen_id' | 'venue_type_id' | 'media_id' | 'weather_id' | 'order_id' | 'country' | 'state' | 'city' | 'postal_code' | 'media_dimension' | 'media_is_portrait' | 'media_is_video'>;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/user-report',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that delete a user's report
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static deleteApiUserReport(
    id: number,
  ): CancelablePromise<{
    id: number;
    name: string;
    description: string;
    createdAt: string;
    updatedAt: string;
    filters: {
      orderIds?: Array<number>;
      campaignIds?: Array<number>;
      sspIds?: Array<number>;
      publisherIds?: Array<string>;
      screenIds?: Array<string>;
      countryIds?: Array<string>;
      stateIds?: Array<string>;
      cityIds?: Array<string>;
      postalCodes?: Array<string>;
      venueTypeIds?: Array<number>;
      mediaIds?: Array<number>;
      mediaDimensions?: Array<string>;
      mediaIsPortrait?: boolean;
      mediaIsVideo?: boolean;
      weatherIds?: Array<number>;
      startDate?: string;
      endDate?: string;
    };
    groupBys: Array<'month' | 'day' | 'week' | 'hour' | 'campaign_id' | 'ssp_id' | 'publisher_id' | 'campaign_coordinate_id' | 'screen_id' | 'venue_type_id' | 'media_id' | 'weather_id' | 'order_id' | 'country' | 'state' | 'city' | 'postal_code' | 'media_dimension' | 'media_is_portrait' | 'media_is_video'>;
    sortBys?: Array<'month' | 'day' | 'week' | 'hour' | 'campaign_id' | 'ssp_id' | 'publisher_id' | 'campaign_coordinate_id' | 'screen_id' | 'venue_type_id' | 'media_id' | 'weather_id' | 'order_id' | 'country' | 'state' | 'city' | 'postal_code' | 'media_dimension' | 'media_is_portrait' | 'media_is_video'>;
  }> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/user-report/{id}',
      path: {
        'id': id,
      },
    });
  }

}
